import {
  NUSDIcon,
} from "../../AssetComponents/Images";
import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { mapStyles } from "../../Components/GoogleMap/Style";
import {
  MapPlusIcon,
  MapMinusIcon,
} from "../../AssetComponents/Images";
import Modal from "react-responsive-modal";
import { GoogleMap, OverlayView, Marker } from "@react-google-maps/api";
import mapPinIcon from "../../assets/images/Dashboard/Dashboard/mappin.svg";
import "react-range-slider-input/dist/style.css";


import { api } from "../../Components/functions/Apiwithouttoken";
import { nibiruApi } from '../../Components/functions/NibiruApi';
import { RentalItem } from "../../Components/RealEstateProperty/RentalItem";
import initialLoadOptimizer from "../../Services/InitialLoadOptimizer";
import { RentalNavigation } from "../../Components/Rent/RentalNavigationComponent";
import { RentalSearch } from "../../Components/Rent/Search";
import Listings from "../../Components/Rent/Listings";
import HomeIcons from "../../Components/Rent/HomeIcons";
import Filter from "../../Components/Rent/Filter";
import Chatbot from "../../Components/Chatbot/Chatbot";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { normalizePricePerDay, hasValidLocation, getSafeLocation } from "../../utils/propertyValidation";

export const RentMobile = () => {
  // Mobile-specific state
  const [mobileView, setMobileView] = useState('list');
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true); // Start with header collapsed
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollTimeoutRef = useRef(null);
  const mobileContentRef = useRef(null);
  
  // Shared state from parent
  const navigate = useNavigate();
  const account = useSelector((state) => state.auth.account);
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [sortType, setSortType] = useState("default");
  const [loading, setLoading] = useState(true);
  const [visibleProperties, setVisibleProperties] = useState([]);
  const ITEMS_PER_BATCH = 8;
  const [zoom, setZoom] = useState(10);
    const [activeToken, setActiveToken] = useState();
  const [pinLocation, setPinLocation] = useState({ lat: 25, lng: 55 });
  const [isSearchResult, setIsSearchResult] = useState(false);
  const [hasLocationInSearch, setHasLocationInSearch] = useState(true); // Track if location was specified in search
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [waitlistData, setWaitlistData] = useState({ name: '', email: '' });    
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  

  
  const location = useLocation();

  // Mobile scroll handler
  const handleScroll = useCallback((event) => {
    const target = event.target;
    const currentScrollY = target.scrollTop;
    
    if (currentScrollY > lastScrollY && currentScrollY > 10) {
      if (!isHeaderCollapsed) {
        setIsHeaderCollapsed(true);
      }
    } else if (currentScrollY < lastScrollY || currentScrollY < 5) {
      if (isHeaderCollapsed) {
        setIsHeaderCollapsed(false);
      }
    }
    
    setLastScrollY(currentScrollY);
    
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
  }, [lastScrollY, isHeaderCollapsed]);

  // Scroll event listener
  useEffect(() => {
    const contentRef = mobileContentRef.current;
    const timeoutRef = scrollTimeoutRef.current;
    if (contentRef) {
      contentRef.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
        contentRef.removeEventListener('scroll', handleScroll);
        if (timeoutRef) {
          clearTimeout(timeoutRef);
        }
      };
    }
  }, [handleScroll]);

  // Load more properties
  const loadMoreProperties = useCallback(() => {
    const nextBatch = filteredProperties.slice(
      visibleProperties.length,
      visibleProperties.length + ITEMS_PER_BATCH
    );
    setVisibleProperties((prev) => [...prev, ...nextBatch]);
  }, [filteredProperties, visibleProperties]);

  // Intersection Observer for infinite scroll
  const observerTarget = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          !loading &&
          visibleProperties.length < filteredProperties.length
        ) {
          loadMoreProperties();
        }
      },
      { threshold: 0.1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => observer.disconnect();
  }, [loading, visibleProperties, filteredProperties, loadMoreProperties]);

  // Get properties
  const getProperties = async () => {
    try {
      setLoading(true);
      const res = await api("property/getProperties", {});
      const propertyArray = Array.isArray(res) ? res : [];
      
      if (propertyArray.length > 0) {
        // Apply filters: isListed === true AND price between $25 and $15,000
        const MIN_VISIBLE_PRICE = 25;
        const MAX_VISIBLE_PRICE = 15000;
        const filteredArray = propertyArray.filter(property => {
          // Check if property has the short object and isListed field
          if (!property?.short) return false;
          
          // Only show properties with isListed === true
          if (property.short.islisted !== true) return false;
          
          // Only show properties with price between $25 and $15,000
          const price = property.short.price_per_day || 0;
          return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
        });
        
        console.log(`RentMobile - Filtered: Total: ${propertyArray.length}, Listed: ${propertyArray.filter(p => p?.short?.islisted === true).length}, Price $25-$15,000: ${filteredArray.length}`);
        
        setProperties(propertyArray);
        setFilteredProperties(filteredArray);
        setVisibleProperties(filteredArray.slice(0, ITEMS_PER_BATCH));
        
        const criticalTokens = filteredArray.slice(0, 6).map(p => p.token_id);
        if (criticalTokens.length > 0) {
          nibiruApi.batchQueryProperties(criticalTokens, 'high')
            .then(() => console.log('Critical properties pre-loaded'));
        }
      } else {
        setProperties([]);
        setFilteredProperties([]);
        setVisibleProperties([]);
      }
    } catch (error) {
      console.error("Failed to fetch properties", error);
      setProperties([]);
      setFilteredProperties([]);
      setVisibleProperties([]);
    } finally {
      setTimeout(() => setLoading(false), 300);
    }
  };

  useEffect(() => {
    getProperties();
  }, []);

  // Aggressive preloading for mobile initial load
  useEffect(() => {
    if (properties.length > 0) {
      console.log('🚀 Starting mobile aggressive preloading...');
      
      // Preload above-the-fold images immediately (first 4 on mobile)
      initialLoadOptimizer.preloadAboveTheFold(properties.slice(0, 4));
      
      // Preload background images after a short delay
      setTimeout(() => {
        initialLoadOptimizer.preloadBackgroundImages(properties.slice(4, 12));
      }, 1500);
    }
  }, [properties]);

    // Search handler
  const handleSearch = async (searchResults) => {
    // Handle special country-not-available response
    if (searchResults && typeof searchResults === 'object' && searchResults.countryNotAvailable === true) {                                                     
      setFilteredProperties([]);
      setVisibleProperties([]);
      setIsSearchResult(true);
      setHasLocationInSearch(true); // Country was specified
      // Store country info for display in waitlist message
      return;
    }

    // Handle case where no location was specified
    if (searchResults && typeof searchResults === 'object' && searchResults.hasLocation === false) {
      setFilteredProperties([]);
      setVisibleProperties([]);
      setIsSearchResult(true);
      setHasLocationInSearch(false); // No location was specified
      return;
    }

    // Clear the no-location flag if we have a regular search
    setHasLocationInSearch(true); // Location was specified or it's a regular search

    if (searchResults && Array.isArray(searchResults) && searchResults.length > 0) {
      // Apply price filter ($25 to $15,000) to search results
      const MIN_VISIBLE_PRICE = 25;
      const MAX_VISIBLE_PRICE = 15000;
      const filteredSearchResults = searchResults.filter(property => {
        const price = property?.short?.price_per_day || 0;
        return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
      });
      
      setFilteredProperties(filteredSearchResults);
      setVisibleProperties(filteredSearchResults.slice(0, ITEMS_PER_BATCH));
      setIsSearchResult(true);
      
      if (filteredSearchResults[0]?.metaData?.location) {
        setPinLocation({
          lat: filteredSearchResults[0].metaData.location.lat,
          lng: filteredSearchResults[0].metaData.location.lng
        });
      }
    } else {
      // Empty search results - clear filtered properties and show no results message
      setFilteredProperties([]);
      setVisibleProperties([]);
      setIsSearchResult(true);
    }
  };

  // Sort handler
  const handleSort = (sortedData) => {
    if (Array.isArray(sortedData) && sortedData.length > 0) {
      // Apply price filter ($25 to $15,000) to sorted data
      const MIN_VISIBLE_PRICE = 25;
      const MAX_VISIBLE_PRICE = 15000;
      const filteredSortedData = sortedData.filter(property => {
        const price = property?.short?.price_per_day || 0;
        return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
      });
      
      setFilteredProperties(filteredSortedData);
      setVisibleProperties(filteredSortedData.slice(0, ITEMS_PER_BATCH));
    } else {
      if (properties.length > 0) {
        // Apply price filter ($25 to $15,000) to all properties
        const MIN_VISIBLE_PRICE = 25;
        const MAX_VISIBLE_PRICE = 15000;
        const filteredProperties = properties.filter(property => {
          const price = property?.short?.price_per_day || 0;
          return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
        });
        
        setFilteredProperties(filteredProperties);
        setVisibleProperties(filteredProperties.slice(0, ITEMS_PER_BATCH));
        alert('No properties found with the selected sort criteria');
      } else {
        setFilteredProperties([]);
        setVisibleProperties([]);
      }
    }
  };

  // Filter handler
  const handleFilterChange = (filteredResults) => {
    if (filteredResults && filteredResults.length > 0) {
      // Apply price filter ($25 to $15,000) to filtered results
      const MIN_VISIBLE_PRICE = 25;
      const MAX_VISIBLE_PRICE = 15000;
      const priceFilteredResults = filteredResults.filter(property => {
        const price = property?.short?.price_per_day || 0;
        return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
      });
      
      setFilteredProperties(priceFilteredResults);
      setVisibleProperties(priceFilteredResults.slice(0, ITEMS_PER_BATCH));
    } else {
      setFilteredProperties([]);
      setVisibleProperties([]);
    }
  };

  // Waitlist handlers
  const handleJoinWaitlist = () => {
    setShowWaitlistModal(true);
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email) {
      alert('Please fill in both name and email');
      return;
    }

    setWaitlistLoading(true);
    
    try {
      const response = await api("waitlist/add", {
        Name: waitlistData.name,
        Email: waitlistData.email
      });
      
      if (response === true) {
        alert('Successfully added to waitlist! We\'ll notify you when properties are available in your area.');
        setShowWaitlistModal(false);
        setWaitlistData({ name: '', email: '' });
      } else {
        alert('Email already exists in our waitlist or there was an error. Please try again.');
      }
    } catch (error) {
      console.error('Waitlist error:', error);
      alert('Failed to add to waitlist. Please try again.');
    } finally {
      setWaitlistLoading(false);
    }
  };

    const handleResetFilters = () => {
    // Reset to show all properties with price filter ($25 to $15,000)
    const MIN_VISIBLE_PRICE = 25;
    const MAX_VISIBLE_PRICE = 15000;
    const filteredArray = properties.filter(property => {
      if (!property?.short) return false;
      if (property.short.islisted !== true) return false;
      const price = property.short.price_per_day || 0;
      return price >= MIN_VISIBLE_PRICE && price <= MAX_VISIBLE_PRICE;
    });

    setFilteredProperties(filteredArray);
    setVisibleProperties(filteredArray.slice(0, ITEMS_PER_BATCH));
    setIsSearchResult(false);
    setHasLocationInSearch(true); // Reset to default
    // Reset pin location to default
    setPinLocation({ lat: 25, lng: 55 });
  };

    // No results prompt component
  const NoResultsPrompt = ({ onJoinWaitlist, onResetFilters, isSearchResult = false, hasLocation = true }) => (                                                                     
    <div className="flex flex-col items-center justify-center text-center p-4 sm:p-6">                                                                          
      {isSearchResult ? (
        <div className="space-y-4 sm:space-y-6 max-w-[90%] sm:max-w-[500px]">   
          <div className="text-xl sm:text-2xl font-semibold text-gray-800">     
            {hasLocation ? "Location not available yet" : "No properties found"}
          </div>
          <div className="text-base sm:text-lg text-gray-600">
            {hasLocation 
              ? "We are not available at that moment in that location. We're expanding! Join our waitlist to be notified when we add properties to your area."
              : "Currently, we don't have any properties for your search criteria. Try adjusting your filters or search for a different location."
            }
          </div>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">                                                                             
            {hasLocation && (
              <PurpleButton
                onClick={onJoinWaitlist}
                text={<span>Join Waitlist</span>}
              />
            )}
            <button
              onClick={onResetFilters}
              className="px-4 sm:px-6 py-2 sm:py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold text-sm sm:text-base"                   
            >
              Reset
            </button>
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-base sm:text-lg text-gray-500">No properties match your filters</p>                                                                
          <PurpleButton
            onClick={onResetFilters}
            text="Reset Filters"
          />
        </div>
      )}
    </div>
  );

  // Waitlist modal component
  const WaitlistModal = () => (
    <Modal
      open={showWaitlistModal}
      center
      onClose={() => setShowWaitlistModal(false)}
      classNames={{
        modal: "w-[95vw] max-w-[400px] rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]",
        overlay: "z-[9999999]",
        modalContainer: "z-[9999999]",
      }}
      styles={{
        modal: {
          zIndex: 9999999,
        },
        overlay: {
          zIndex: 9999999,
        },
      }}
    >
      <div className="p-4 sm:p-6">
        <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4">Join Our Waitlist</h2>
        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
          Be the first to know when we add properties to your desired location!
        </p>
        
        <div className="space-y-3 sm:space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Name
            </label>
            <input
              type="text"
              value={waitlistData.name}
              onChange={(e) => setWaitlistData({ ...waitlistData, name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm sm:text-base"
              placeholder="Enter your name"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              type="email"
              value={waitlistData.email}
              onChange={(e) => setWaitlistData({ ...waitlistData, email: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm sm:text-base"
              placeholder="Enter your email"
            />
          </div>
        </div>
        
        <div className="flex gap-3 mt-4 sm:mt-6">
          <button
            onClick={() => setShowWaitlistModal(false)}
            className="flex-1 px-3 sm:px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 text-sm sm:text-base"
            disabled={waitlistLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleWaitlistSubmit}
            className="flex-1 px-3 sm:px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 text-sm sm:text-base"
            disabled={waitlistLoading}
          >
            {waitlistLoading ? 'Adding...' : 'Join Waitlist'}
          </button>
        </div>
      </div>
    </Modal>
  );

  // Map properties: Show the SAME properties as the list view (filteredProperties)
  // This ensures the map shows exactly what's visible in the list panel
  // Filter to only include properties with valid location data
  const mapProperties = (filteredProperties || []).filter((nft) => {
    // Use helper function to validate location coordinates (not 0, valid numbers, within bounds)
    return hasValidLocation(nft);
  });
  
  // Debug logging for map properties
  useEffect(() => {
    const filteredWithLocation = (filteredProperties || []).filter(p => hasValidLocation(p));
    const filteredWithoutLocation = (filteredProperties || []).filter(p => !hasValidLocation(p));
    
    console.log('🗺️ RentMobile - Map Properties Debug:', {
      totalProperties: properties.length,
      filteredProperties: filteredProperties.length,
      mapProperties: mapProperties.length,
      filteredWithLocation: filteredWithLocation.length,
      filteredWithoutLocation: filteredWithoutLocation.length,
      activeToken: activeToken,
      mapPropertiesDetails: mapProperties.slice(0, 20).map(p => ({
        token_id: p?.token_id,
        price: normalizePricePerDay(p?.short?.price_per_day || 0),
        location: p?.metaData?.location,
        hasValidLocation: hasValidLocation(p),
        islisted: p?.short?.islisted,
        isActive: p?.token_id === activeToken
      }))
    });
  }, [properties.length, filteredProperties.length, mapProperties.length, activeToken, account]);

  return (
    <>
      <div className="flex flex-col w-full h-full">
        <div className="w-full h-full flex flex-col">
          {/* Mobile Header - Collapsible with Modal Support */}
          <div className={`fixed top-0 left-0 right-0 z-[50] bg-white transition-all duration-300 ease-in-out ${
            isHeaderCollapsed ? 'shadow-lg' : ''
          }`} style={{ top: '60px' }}>
            
            {/* Search Bar - Collapsible */}
            <div className={`px-4 transition-all duration-300 ease-in-out ${
              isHeaderCollapsed ? 'h-0 py-0 opacity-0 overflow-hidden' : 'py-3 opacity-100'
            } border-b border-gray-100`}>
              <div className={`transition-all duration-300 ease-in-out ${
                isHeaderCollapsed ? 'scale-95 opacity-80' : 'scale-100 opacity-100'
              }`}>
                <RentalSearch onSearch={handleSearch} onReset={() => {
                  setIsSearchResult(false);
                  setHasLocationInSearch(true);
                  // Reload properties to initial state
                  if (typeof loadTrips === 'function') {
                    // no-op placeholder if mobile uses a different loader
                  }
                }} />
              </div>
            </div>
            
            {/* Filter, Navigation, and Listings Controls - Collapsible */}
            <div className={`px-4 transition-all duration-300 ease-in-out ${
              isHeaderCollapsed 
                ? 'h-0 py-0 opacity-0 pointer-events-none transform -translate-y-4' 
                : 'h-auto py-4 opacity-100 pointer-events-auto transform translate-y-0'
            } border-b border-gray-100`}>
              <div className={`space-y-4 transition-all duration-300 ease-in-out ${
                isHeaderCollapsed ? 'scale-95' : 'scale-100'
              }`}>
                <div className="flex items-center justify-between w-full gap-3">
                  <Filter
                    properties={properties} 
                    onFilterChange={handleFilterChange}
                    currentSortType={sortType}
                  />
              
                  <RentalNavigation />
                
                                     <Listings 
                     onSort={handleSort} 
                     setSortType={setSortType}
                     filteredProperties={filteredProperties}
                   />
                </div>
              </div>
            </div>

            {/* Map/List Toggle - Collapsible */}
            <div className={`px-4 transition-all duration-300 ease-in-out ${
              isHeaderCollapsed 
                ? 'h-0 py-0 opacity-0 pointer-events-none transform -translate-y-4' 
                : 'h-auto py-3 opacity-100 pointer-events-auto transform translate-y-0'
            } bg-white border-t border-gray-100`}>
              <div className={`transition-all duration-300 ease-in-out ${
                isHeaderCollapsed ? 'scale-95' : 'scale-100'
              }`}>
                <div className="flex items-center justify-center bg-gray-100 rounded-lg p-1 shadow-sm">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      console.log('List button clicked');
                      setMobileView('list');
                    }}
                    className={`flex-1 py-3 px-6 rounded-md text-sm font-medium transition-colors ${
                      mobileView === 'list'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-500 hover:text-gray-700'
                    }`}
                    style={{ minHeight: '44px' }}
                  >
                    List 
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      console.log('Map button clicked');
                      setMobileView('map');
                    }}
                    className={`flex-1 py-3 px-6 rounded-md text-sm font-medium transition-colors ${
                      mobileView === 'map'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-500 hover:text-gray-700'
                    }`}
                    style={{ minHeight: '44px' }}
                  >
                    Map 
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Floating Action Button for Collapsed Header */}
          {isHeaderCollapsed && (
            <div className="fixed top-20 right-4 z-[60]">
              <button
                onClick={() => setIsHeaderCollapsed(false)}
                className="p-3 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
                style={{ minHeight: '44px', minWidth: '44px' }}
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              </button>
            </div>
          )}

          {/* Main Content */}
          {(location.pathname.split("/")[2] === "short" ||
            location.pathname.split("/")[2] === "all") && (
            <>
              {/* Mobile Content */}
              <div className="w-full h-full">
                {mobileView === 'list' ? (
                  <div 
                    ref={mobileContentRef}
                    className={`mobile-content-scroll w-full h-full overflow-y-auto px-2 sm:px-4 pb-20 flex justify-center transition-all duration-300 ease-in-out ${
                      isHeaderCollapsed ? 'pt-20' : 'pt-64'
                    }`}
                  >
                    <div className="w-full max-w-lg sm:max-w-xl space-y-3 sm:space-y-4 py-4 mobile-rental-list">
                      {loading ? (
                        <div className="flex items-center justify-center min-h-[300px]">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
                        </div>
                      ) : filteredProperties?.length > 0 ? (
                        filteredProperties.map((nft, index) => (
                          <div 
                            key={index} 
                            className="w-full flex justify-center mobile-rental-item-wrapper"
                            onMouseEnter={() => setActiveToken(nft?.token_id)}
                            onMouseLeave={() => setActiveToken(null)}
                            onTouchStart={() => setActiveToken(nft?.token_id)}
                            onTouchEnd={() => setTimeout(() => setActiveToken(null), 2000)}
                          >
                            <div className="w-full max-w-md mobile-rental-item mobile-rental-item-compact">
                              <RentalItem
                                token_id={nft?.token_id}
                                tokenData={nft}
                                variant="wide"
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                                                <div className="flex items-center justify-center min-h-[300px]">                                                                        
                          <NoResultsPrompt
                            onJoinWaitlist={handleJoinWaitlist}
                            onResetFilters={handleResetFilters}
                            isSearchResult={isSearchResult}
                            hasLocation={hasLocationInSearch}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  /* Mobile Map View - Optimized for Performance */
                 <div className={`w-full h-screen transition-all duration-300 ease-in-out mobile-map-container ${
                   isHeaderCollapsed ? 'pt-20' : 'pt-64'
                 }`} style={{ zIndex: 5 }}>
                                         <GoogleMap
         center={pinLocation}
         zoom={zoom}
         mapContainerClassName="w-full h-full"
         options={{
                         styles: mapStyles,
                         // Mobile performance optimizations
                         gestureHandling: 'greedy',
                         disableDefaultUI: true,
                         clickableIcons: false,
                         // Reduce map complexity on mobile
                         maxZoom: 18,
                         minZoom: 10,
                         // Optimize rendering
                         backgroundColor: '#f8f9fa',
                         // Disable unnecessary features on mobile
                         tilt: 0,
                         heading: 0,
                         // Reduce memory usage
                         preserveDrawingBuffer: false,
                         // Control visibility
                         mapTypeControl: false,
                         streetViewControl: false,
                         fullscreenControl: false,
                         zoomControl: false,
                         scaleControl: false,
                         rotateControl: false,
                         // Optimize for mobile
                         draggableCursor: 'grab',
                         draggingCursor: 'grabbing',
                         // Reduce animation duration
                         animation: 0,
                         // Optimize rendering
                         optimized: true,
                       }}
                     >
                                                                                         {/* Simplified Map Controls for Mobile */}
                     <div className="absolute top-4 right-4 flex flex-col gap-2 mobile-map-controls z-[8]">
         <div
           className="p-3 rounded-full shadow-lg bg-white hover:bg-gray-50 cursor-pointer mobile-map-control-button mobile-touch-target touch-manipulation"
           onClick={(e) => {
             e.preventDefault();
             e.stopPropagation();
             setZoom(Math.min(zoom + 1, 18));
           }}
           onTouchStart={(e) => e.preventDefault()}
         >
                           <MapPlusIcon />
                         </div>
                         <div
             className="p-3 rounded-full shadow-lg bg-white hover:bg-gray-50 cursor-pointer mobile-map-control-button mobile-touch-target touch-manipulation"
             onClick={(e) => {
               e.preventDefault();
               e.stopPropagation();
               setZoom(Math.max(zoom - 1, 10));
             }}
             onTouchStart={(e) => e.preventDefault()}
           >
                           <MapMinusIcon />
                         </div>
                       </div>

                      {/* Floating List Button for Easy Access */}
                      <div className="absolute top-4 left-4 z-[8]">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Floating list button clicked');
                            setMobileView('list');
                          }}
                          className="flex items-center gap-2 px-4 py-3 bg-white rounded-full shadow-lg hover:bg-gray-50 mobile-touch-target"
                          style={{ minHeight: '44px' }}
                        >
                          <span className="text-lg">←</span>
                          <span className="text-sm font-medium">List</span>
                        </button>
                      </div>

                                             {/* Optimized Property Markers for Mobile */}
                       {(() => {
                         // 🔧 FIX: Group properties by identical coordinates and spread them out
                         const locationGroups = {};
                         const processedProperties = [];
                         
                         mapProperties.forEach((nft, idx) => {
                           const loc = getSafeLocation(nft);
                           if (!loc) return;
                           const key = `${loc.lat.toFixed(5)},${loc.lng.toFixed(5)}`;
                           if (!locationGroups[key]) {
                             locationGroups[key] = [];
                           }
                           locationGroups[key].push({ nft, originalIndex: idx, location: loc });
                         });

                         let globalIndex = 0;
                         Object.entries(locationGroups).forEach(([key, group]) => {
                           const baseLocation = group[0].location;
                           const offsetDegrees = 0.002;
                           const clusterSize = Math.ceil(Math.sqrt(group.length));
                           
                           group.forEach(({ nft, originalIndex }, groupIndex) => {
                             const row = Math.floor(groupIndex / clusterSize);
                             const col = groupIndex % clusterSize;
                             const currentIndex = globalIndex++;
                             
                             const propertyLocation = {
                               lat: baseLocation.lat + (row * offsetDegrees * 0.3) - (clusterSize * offsetDegrees * 0.15),
                               lng: baseLocation.lng + (col * offsetDegrees * 0.3) - (clusterSize * offsetDegrees * 0.15)
                             };
                             
                             processedProperties.push({
                               nft,
                               propertyLocation,
                               originalIndex,
                               currentIndex
                             });
                           });
                         });

                         return processedProperties.map(({ nft, propertyLocation, currentIndex }) => {
                           const offsetX = (currentIndex % 5) * 2 - 4;
                           const offsetY = (Math.floor(currentIndex / 5) % 5) * 2 - 4;
                         
                         return (
                           <OverlayView
                             position={propertyLocation}
                             mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                             key={nft?.token_id || `mobile-map-${currentIndex}`}
                             className="mobile-map-overlay"
                             getPixelPositionOffset={(width, height) => ({
                               x: -(width / 2) + offsetX,
                               y: -height + offsetY,
                             })}
                           >
                             <div 
                               className="mobile-property-marker"
                               style={{ position: 'relative', zIndex: nft?.token_id === activeToken ? 1000 : 100 + currentIndex }}
                             >
                               <div
                                 onClick={(e) => {
                                   e.preventDefault();
                                   e.stopPropagation();
                                   navigate(location.pathname + "/" + nft?.token_id);
                                 }}
                                 onTouchStart={(e) => {
                                   e.preventDefault();
                                   setActiveToken(nft?.token_id);
                                 }}
                                 onTouchEnd={(e) => {
                                   e.preventDefault();
                                   setTimeout(() => setActiveToken(null), 2000);
                                 }}
                                 className={
                                   nft?.token_id === activeToken
                                     ? "w-max px-[12px] py-[6px] rounded-[16px] bg-[#5b1dee] text-white text-center cursor-pointer shadow-lg mobile-map-marker-simple touch-manipulation"
                                     : "w-max px-[12px] py-[6px] rounded-[16px] bg-[#5b1dee] hover:bg-[#4a1ac7] text-white text-center cursor-pointer shadow-lg mobile-map-marker-simple touch-manipulation"
                                 }
                                 style={{ touchAction: 'manipulation' }}
                               >
                                 <div className="flex items-center gap-[2px]">
                                   <NUSDIcon className="w-[14px]" />
                                   <div className="text-xs font-semibold">
                                     ${normalizePricePerDay(nft?.short?.price_per_day || 0)}
                                   </div>
                                 </div>
                               </div>
                               {nft?.token_id === activeToken && (
                                 <div 
                                   className="scale-x-[0.35] scale-y-[0.25] left-[-25px] origin-top absolute mobile-marker-popup"
                                   style={{ zIndex: 9999 }}
                                 >
                                   <RentalItem
                                     token_id={nft?.token_id}
                                     confetti={false}
                                     tokenData={nft}
                                   />
                                 </div>
                               )}
                             </div>
                           </OverlayView>
                         );
                         });
                       })()}

                      {/* Simplified Marker for Mobile */}
                      <Marker
                        position={pinLocation}
                        draggable={false}
                        icon={{
                          url: mapPinIcon,
                          scaledSize: new window.google.maps.Size(40, 40),
                          origin: new window.google.maps.Point(0, 0),
                          anchor: new window.google.maps.Point(20, 34),
                        }}
                      />
                    </GoogleMap>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Long Term Rental Section */}
          {location.pathname.split("/")[2] === "long" && (
            <div className="w-full h-full flex-col items-center justify-center flex max-h-[calc(100vh-200px)]">
              <div className="scale-75 sm:scale-100">
                <HomeIcons />
              </div>
              <div className="text-[#202020] text-sm sm:text-base">Coming soon</div>
            </div>
          )}
        </div>
        <div className="fixed bottom-20 mt-2 right-4 z-[9999]">
          <Chatbot />
        </div>
      </div>
      <WaitlistModal />
    </>
  );
};
